import React from 'react'
import { Outlet } from 'react-router-dom'

const OfferWrapper = () => {
  return (
    <div><Outlet/></div>
  )
}

export default OfferWrapper